import { css } from '@emotion/css';
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import AnimateWrapper from '../util/AnimateWrapper';
import { useBreadcrumbs } from '../util/BreadcrumbContext';
import ChoiceCard from '../util/ChoiceCard';

const LandingPage = () => {
    const { addBreadcrumb } = useBreadcrumbs();

    return (
        <AnimateWrapper>
            <h2>Verzendingen buiten de EU</h2>
            <Card>
                <Card.Body>
                    <p>
                        U heeft aangegeven gebruik te willen maken van onze
                        diensten voor het aanmaken van een zending buiten de EU.
                        Via deze wizard verzamelen wij de benodigde informatie
                        stap voor stap.
                    </p>
                    <p className='fw-light'>
                        De servicekosten voor het verzorgen van de verzending
                        bedragen €15,-. LET OP: hier komen de verzendkosten en
                        eventueel andere gemaakte kosten nog bovenop.
                    </p>
                    <p>
                        Wilt u dit toch liever zelf verzorgen? Klik dan{' '}
                        <a
                            href='https://help.vinologix.com/support/solutions/folders/80000703009'
                            target='_blank'
                            // onClick={(e) => {
                            //     e.preventDefault();
                            //     addBreadcrumb({
                            //         href: '/manuals',
                            //         text: 'Handleidingen'
                            //     });
                            // }}
                        >
                            hier
                        </a>{' '}
                        voor de benodigde handleidingen. En vraag een DHL
                        Express account aan bij Vinologix.
                    </p>
                </Card.Body>
            </Card>
            <ChoiceCard
                className={'mt-3'}
                body='Ga verder'
                onClick={() => {
                    addBreadcrumb({
                        href: '/from',
                        text: 'Land van'
                    });
                }}
            />
        </AnimateWrapper>
    );
};

export default LandingPage;
